import { usePropertyStreet1 } from '../../../../../queries/usePropertyCoreFields';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface PropertyAddressStreet1Props {
    propertyGuid: string;
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
    validator?: React.ReactNode;
}

export const PropertyAddressStreet1: React.FC<PropertyAddressStreet1Props> = ({
    propertyGuid,
    required = false,
    readOnly = false,
    isReview = false,
    validator,
}) => {
    const label = 'Street Address';
    const [propertyAddressStreet1, set_propertyAddressStreet1] = usePropertyStreet1(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={propertyAddressStreet1}
                />
            ) : (
                <TextBox
                    id='propertyAddressLine1'
                    value={propertyAddressStreet1}
                    onChange={(value) => set_propertyAddressStreet1(value)}
                    label={label}
                    placeholder='123 Main Street'
                    required={required}
                    width='100%'
                    readOnly={readOnly}
                    maxLength={50}
                    validator={validator}
                />
            )}
        </>
    );
};
